export default __webpack_public_path__ + "static/media/cs_picture.65c9b301.jpeg";